import controllers from "@/controllers";

/**
 * @summary Obtém as configurações construtivas do ativo.
 * @param {number} monitoringElementId Id do elemento de monitoramento tipo unidade geradora.
 * @returns Configuração construtiva do ativo.
 */
const GetKinematicConfiguration = async function(monitoringElementId)
{
	const resp = await controllers.KinematicParameters.GetKinematicConfiguration(monitoringElementId);

	if (resp.status === 204) return {};

	return resp.data;
};

/**
 * Cria as configurações construtivas do ativo.
 * @param {number} id Id do elemento de monitoramento tipo unidade geradora.
 * @param {object} assetConfiguration Configuração construtiva.
 */
const CreateKinematicConfiguration = async function(assetConfiguration)
{
	const resp = await controllers.KinematicParameters.CreateKinematicConfiguration(assetConfiguration);

	if (resp.status === 201) return resp.data;
	return "";
};

export default {
	GetKinematicConfiguration,
	CreateKinematicConfiguration,
};